import apisauce from 'apisauce';
import ApiMonitor from './apiMonitor';
import AppConfig from '../../config/appConfig';

const create = () => {
    // define the api
    const partsApi = apisauce.create({
        baseURL: AppConfig.apiUrl,
        headers: {
            'cache-control': 'no-cache',
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        timeout: 10000,
        mode: 'no-cors',
    });

    // Wrap api's addMonitor to allow the calling code to attach
    // additional monitors in the future.  But only in __DEV__ and only
    // if we've attached Reactotron to console (it isn't during unit tests).
    /* if (AppConfig.isDevelopmentMode && console.tron) {
        partsApi.addMonitor(console.tron.apisauce);
    } */

    // Add some monitors for the request connection. Also shows alerts with the best
    // matching message.
    ApiMonitor(partsApi);

    // Define some functions that call the api.  The goal is to provide
    // a thin wrapper of the api layer providing nicer feeling functions
    // rather than "get", "post" and friends.
    //
    // I generally don't like wrapping the output at this level because
    // sometimes specific actions need to be take on `403` or `401`, etc.
    //
    // Since we can't hide from that, we embrace it by getting out of the
    // way at this level.
    //
    /* eslint-disable prefer-template */
    const listParts = (category, identifier, locale) => partsApi.get('parts/' + category, { model: identifier, L: locale });
    /* eslint-enable prefer-template */

    return {
        listParts,
    };
};

export default {
    create,
};
